import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    SELECT_FIELD_TYPE,
} from "../../helpers/constants";

import { AgreementPassportButton } from "../AgreementsPage/AgreementPassportDialog/AgreementPassportButton";

export const TABLE_NAME = "agreements_table";
import { useInvestments } from "../../services/productsService";


export const useTableFieldsConfig = () => {
    const { t } = useTranslation();

    const { data: investments, isLoading: isInvestmentLoading } = useInvestments({
        select: (data) =>
            data.results.map((investment) => ({
                value: investment.id,
                label: investment.investment_name_sales,
            })),
    });

    return [
        {
            name: "agreement_nr",
            getValueCallback: (rowData) => rowData.agreement_nr,
            label: t("table.agreements.agreementNr"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: () => undefined,
            sortable: true,
        },
        {
            name: "customer_full_name",
            getValueCallback: (rowData) => rowData.agreement_customer_person, 
            label: t("table.agreements.customerFullNames"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: () => undefined,
            sortable: false,
        },
        {
            name: "counterparty_names",
            getValueCallback: (rowData) => rowData.agreement_customer_company,
            label: t("table.agreements.companyNames"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: () => undefined,
            sortable: false,
        },
        {
            name: "investment",
            getValueCallback: (rowData) => rowData.agreement_invest.investment_name_sales,
            label: t("table.agreements.investment"),
            filterType: SELECT_FIELD_TYPE,
            getFilterFieldConfigCallback: () => ({
                optionKey: "value",
                optionLabel: "label",
                options: investments,
                multiple: false,
            }),
            fieldConfig: {
                optionKey: "value",
                optionLabel: "label",
                options: investments,
            },
            sortable: false,
        },
        {
            name: "agreement_notarial_deed",
            getValueCallback: (rowData) => rowData.agreement_notarial_deed || "",
            label: t("table.agreements.agreementNotarialDeed"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: () => undefined,
            sortable: true,
        },
        {
            name: "product_numbers",
            getValueCallback: (rowData) => rowData.agreement_local,
            label: t("table.agreements.productNumbers"),
            filterType: TEXT_FIELD_TYPE,
            getFilterFieldConfigCallback: () => undefined,
            sortable: false,
        },
        {
            name: "passport",
            getValueCallback: (rowData) => <AgreementPassportButton agreement={{id:rowData.id}} />,
            label: t("table.agreements.passport"),
            getFilterFieldConfigCallback: () => undefined,
            sortable: false,
        },
    ]
};